import { Component, Input } from "@angular/core";

@Component({
    selector: 'mytab',
    template: `
    <ng-content *ngIf="active"></ng-content>
  `
})
export class MyTab {

    @Input() tabIndex: number = 1;
    @Input() title = '';
    @Input() active = false;
    @Input() disabled = false;

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/directives/mytab.ts